<button class="td-wb-confirm-button"
        tdWbButton
        [tdWbButtonType]="buttonType()"
        [tdWbModalClose]="value()">
  <ng-content />
</button>
